import React from "react";

function About() {
  return (
    <div>
      <label>about pagecontent</label>
    </div>
  );
}

export default About;
